import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      login(data.token, data.user);
      toast.success(`Welcome back, ${data.user.name}!`);
      navigate("/");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid-bg min-h-[calc(100vh-73px)] flex items-center">
      <div className="max-w-md w-full mx-auto px-6 py-16">
        <h1 className="font-display font-extrabold text-4xl tracking-tighter mb-2">Log in</h1>
        <p className="text-zinc-500 text-sm mb-8">Back to the fastest auctions on the web.</p>
        <form onSubmit={submit} className="card-surface p-6 space-y-4">
          <div>
            <label className="text-xs uppercase tracking-widest text-zinc-500 mb-2 block">
              Email
            </label>
            <input
              type="email"
              required
              className="input-field"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email-input"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-zinc-500 mb-2 block">
              Password
            </label>
            <input
              type="password"
              required
              className="input-field"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password-input"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="btn-bid w-full text-sm"
            data-testid="login-submit-button"
          >
            {loading ? "Signing in…" : "Sign In"}
          </button>
          <div className="text-center pt-2">
            <Link
              to="/forgot-password"
              className="text-xs text-zinc-400 hover:text-[#FBBF24] hover:underline"
              data-testid="forgot-password-link"
            >
              Forgot password?
            </Link>
          </div>
        </form>
        <p className="text-zinc-500 text-sm mt-6 text-center">
          Don't have an account?{" "}
          <Link to="/register" className="text-[#FBBF24] hover:underline">
            Sign up
          </Link>
        </p>
        <p className="text-zinc-600 text-xs mt-8 text-center">
          Demo: demo@pennyauction.com / Demo@12345
        </p>
      </div>
    </div>
  );
}
